import { render, staticRenderFns } from "./Data_Protection.vue?vue&type=template&id=413b9427&"
import script from "./Data_Protection.vue?vue&type=script&lang=js&"
export * from "./Data_Protection.vue?vue&type=script&lang=js&"
import style0 from "./Data_Protection.vue?vue&type=style&index=0&id=413b9427&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports